/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type AppHeaderSettingLinkViewerFragment = { profile: { name: string, avatar: any }, staff: { email: string } };

export const AppHeaderSettingLinkViewerFragmentDoc = gql`
    fragment AppHeaderSettingLinkViewer on Viewer {
  profile {
    name
    avatar
  }
  staff {
    email
  }
}
    `;